import { Check, Copy } from 'lucide-react';
import { useState, useCallback } from 'react';

import { Button } from '@/components/ui/button';

interface CopyButtonProps {
  text: string;
  className?: string;
}

export function CopyButton({
  text,
  className,
}: CopyButtonProps): React.ReactElement {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback((): void => {
    void (async (): Promise<void> => {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        // Note: execCommand is deprecated but needed for fallback
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      }
    })();
  }, [text]);

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleCopy}
      className={className}
      aria-label={copied ? 'コピーしました' : 'コピー'}
    >
      {copied ? (
        <>
          <Check className="h-4 w-4" />
          <span>コピーしました</span>
        </>
      ) : (
        <>
          <Copy className="h-4 w-4" />
          <span>コピー</span>
        </>
      )}
    </Button>
  );
}
